// Works as simple wrapper around async storage
export function setItem(key, value) {
  return localStorage.setItem(key, value);
}

export function getItem(key) {
  return localStorage.getItem(key);
}

export function removeItem(key) {
  return localStorage.removeItem(key);
}

export default {
  set: setItem,
  get: getItem,
  remove: removeItem,
};
